import { Modal } from "antd";
import BtnEditSvg from "../Button/btnEditSvg";
import { useState } from "react";
import EmployeeEmploymentStatus from "../EmployeementStatus";
import Loader from "../../loader/loader";
import EmploymentAddSinglePopup from "./EmploymentAddSinglePopup";
import PaymentTypeStatus from "../PaymentTypeStatus";
import PaymentTypeAddSinglePopup from "./PaymentTypeAddPopup";
import WeeklyWorkingDayAddSinglePopup from "./WeeklyWorkingDayAddPopup";
import WeeklyWorkingDaysStatus from "../WeeklyWorkingDayStatus";

const WeeklyWorkingPopup = ({ data }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };
  
    return (
      <>
        <button onClick={showModal} className="mt-4 mr-2">
          <BtnEditSvg size={25} />
        </button>
        <Modal
          title="Edit Weekly Working Days"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {!loading ? (
            <>
              <WeeklyWorkingDaysStatus
                list={data}
                edit={true}
                setLoading={setLoading}
              />
              <WeeklyWorkingDayAddSinglePopup
                list={data}
                setLoading={setLoading}
              />
            </>
          ) : (
            <Loader />
          )}
        </Modal>
      </>
    );
  };

  export default WeeklyWorkingPopup;
  